import { Outlet, useLocation } from 'react-router-dom'
import { SessionCaptureProvider } from '@/contexts/SessionCaptureContext'
import { ErrorBoundary } from '@/components/ErrorBoundary'

export function RootLayout() {
  const { pathname } = useLocation()

  return (
    <SessionCaptureProvider>
      <div className="min-h-screen flex flex-col">
        <main className="flex-1">
          <ErrorBoundary level="page" resetKey={pathname}>
            <Outlet />
          </ErrorBoundary>
        </main>
      </div>
    </SessionCaptureProvider>
  )
}
